import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Login from "./pages/login/Login";
import App from "./App";

if (
  sessionStorage.getItem("mwerezi_mpos_username") !== null ||
  localStorage.getItem("mpos_fullnames") !== null
) {
  ReactDOM.render(
    <BrowserRouter>
      <App
        username={sessionStorage.getItem("mwerezi_mpos_username")}
        fullnames={localStorage.getItem("mpos_fullname")}
      />
    </BrowserRouter>,
    document.getElementById("root")
  );
} else {
  ReactDOM.render(<Login />, document.getElementById("root"));
}
